import styled from "@emotion/styled"
import { Autocomplete, TextField } from "@mui/material"
import SectionTitles from "./SectionTitles"

type Props = {
  title: string
  subtitle: string
  messages: any
  onCityChange: any
  onProjectChange: any
  selectedCity: string | null
  selectedProject: string | null
  cities: string[]
  projects: string[]
}

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding-top: 20px;
`

const StyledFieldsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  align-items: center;

  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    justify-content: center;
    gap: 40px;
  }

  .MuiAutocomplete-root {
    width: 100%;
    ${(props) => props.theme.breakpoints.up("md")} {
      width: 328px;
    }
  }

  .MuiOutlinedInput-root {
    height: 56px;
    font-size: 18px;

    fieldset {
      border-color: black;
    }
  }

  .MuiInputLabel-root {
    font-size: 18px;
    color: #000000;
  }
`

const CityProjectSelection = ({
  title,
  subtitle,
  messages,
  onCityChange,
  onProjectChange,
  selectedCity,
  selectedProject,
  cities,
  projects,
}: Props) => {
  return (
    <StyledDiv>
      <SectionTitles title={title} subtitle={subtitle} />
      <StyledFieldsRow>
        <Autocomplete
          options={cities}
          value={selectedCity}
          onChange={onCityChange}
          renderInput={(params) => <TextField {...params} label={messages.cityLabel} />}
          noOptionsText=""
        />
        <Autocomplete
          options={projects}
          value={selectedProject}
          onChange={onProjectChange}
          disabled={!selectedCity}
          renderInput={(params) => <TextField {...params} label={messages.projectLabel} />}
          noOptionsText=""
        />
      </StyledFieldsRow>
    </StyledDiv>
  )
}

export default CityProjectSelection
